
import styled from 'styled-components';
//worth noting, the styled-components library does automatic
//vendor-prefixing for any styles!

/*
These are the big layout components. UI components get fitted into these.
*/

export const Row = styled.div`
  padding: ${props => props.space ? props.space : '0'};
  display: flex;
  flex-direction: row;
  width: ${props => props.rowWidth ? props.rowWidth: "100%"};
  justify-content: ${props => props.rowJustify ? props.rowJustify: "center"};
  align-items: ${props => props.rowAlign ? props.rowAlign: "stretch"};

  @media (max-width: 700px) {
		flex-direction: ${props => props.stack ? 'column' : 'row'};
    align-items: ${props => props.middle ? 'center' : 'flex-start'};
      width: ${props => props.rowWidthSm ? props.rowWidthSm: "100%"};
	}
`

export const Column = styled.div`
  padding: ${props => props.space ? props.space : '0'};
  display: flex;
  background: ${props => props.colBkgd ? props.colBkgd : 'none'};
  width: ${props => props.colWidth ? props.colWidth: "100%"};
  max-width: ${props => props.colMaxWidth ? props.colMaxWidth: "none"};
  flex-direction: column;
  justify-content: ${props => props.colJustify ? props.colJustify: "flex-start"};
  align-items: ${props => props.colAlign ? props.colAlign : 'flex-start'};
  @media (max-width: 700px){
    width: ${props => props.colWidthSm ? props.colWidthSm : "100%"};
    order: ${props => props.colOrder ? props.colOrder : 'unset' };
  }
`

export const Container = Column.extend`
  justify-content: center;
  width:100%;
  align-items: center;
`

export const FlexSpan = styled.span`
  flex:2;
`



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/layoutComponents.js